import {Component, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, HostListener} from '@angular/core';
import {takeWhile} from 'rxjs/operators';
import {ApiService} from '../shared/api.service';
import {Utils} from '../utils';
@Component({
    selector: 'tags-component',
    templateUrl: 'tags.component.html'
})
export class TagsComponent {
    options = [];
    searchText = '';
    terms = [];
    termsLoaded = false;
    placeholder = 'Tags';
    inputSearchTags = this.utils.rand();

    private _canEdit = false;
    private _termIds = [];

    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('termIds')
    set termIds(termIds) {
        if( this.termsLoaded && !this.isEqual(termIds, this._termIds) ) {
            this.loadTerms(termIds);
        }
        this._termIds = termIds;
    }
    get termIds() {
        return this._termIds;
    }
    @Output() termIdsChange = new EventEmitter();

    @ViewChild('searchInput') searchInput; 

    constructor(private api: ApiService, private cdr: ChangeDetectorRef, public utils: Utils) {}
    ngAfterViewInit() {
        if( this.termIds.length > 0 ) {
            this.placeholder = '';
            this.loadTerms(this.termIds);
        } else {
            this.termsLoaded = true;
        }
    }
    isEqual(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }
    loadTerms(termIds) {
        this.getTerms(termIds).subscribe(
            data => {
                this.terms = data;
                this.termIdsChange.emit(this.termIds);
                this.termsLoaded = true;
            }
        );
    }
    addTerm(option) {
        const terms = this.terms;
        let hasTemp = false;
        for(var i = 0; i < terms.length; i++) {
            const term = terms[i];
            if( term.id === 0 && option.name.toLowerCase() == term.name.toLowerCase() ) {
                this.terms[i] = option;
                hasTemp = true;
                break;
            }
        }
        if( !hasTemp ) {
            this.terms.push(option);
        }
        this.termIds.push(option.term_id);
        this.termIdsChange.emit(this.termIds);
        this.searchText = '';
    }
    createTerm(text) {
        if( text == '' || this.hasTerm(text) ) {
            return;
        }
        this.searchText = '';
        this.terms.push({name: text, id: 0});
        this.api.doAction('post', 'taxonomy', {
            action: 'add_term',
            taxonomy: 'post_tag',
            name: text
        }).subscribe(
            data => {
                const stillThere = this.terms.filter(item => item.name.toLowerCase() == data.name.toLowerCase()).shift();
                if( stillThere !== undefined ) {
                    this.addTerm(data);
                }
            }
        )
    }
    hasTerm(text) {
        const terms = this.terms;
        const term = text.toLowerCase();
        for(var i = 0; i < terms.length; i++) {
            if( term == terms[i].name.toLowerCase() ) {
                return true;
            }
        }
        return false;
    }
    getTerms(termIds) {
        return this.api.doAction('post', 'taxonomy', {
            action: 'get_terms',
            taxonomy: 'post_tag',
            include: termIds.join(',')
        });
    }
    addOrCreateTerm(text) {
        let selected = this.options.filter(item => item.selected);
        if( selected.length > 0 ) {
            this.addTerm(selected[0]);
            this.options = [];
            this.searchText = '';
        } else {
            this.createTerm(text);
        }
    }
    removeTerm(e, index) {
        if( this.terms.length == 0 || (e.keyCode == 8 && this.searchText != '') ) {
            return;
        }
        const termId = this.terms[index].term_id;
        let i = this.termIds.length;
        while(i--) {
            if( this.termIds[i] == termId ) {
                this.termIds.splice(i, 1);
                break;
            }
        }
        this.terms.splice(index, 1);
        this.termIdsChange.emit(this.termIds);
    }
    maybeReset(e) {
        setTimeout(() => { // allow option click
            this.options = [];
        }, 250);
    }
    search(text) {
        let searching = false;
        if( text == '' ) {
            this.options = [];
            return;
        }
        searching = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'get_terms',
            taxonomy: 'post_tag',
            search: text,
            exclude: this.termIds.join(','),
            limit: 30
        }).pipe(
            takeWhile(() => searching === true)
        ).subscribe(
            data => {
                this.options = data;
                this.cdr.detectChanges();
            }
        )
    }
    selectDown(e) {
        if( this.searchText == '' ) {
            return;
        }
        e.preventDefault();
        let index = 0;
        const last = this.options.length - 1;
        this.options = this.options.map((item, i) => {
            if( item.selected && i !== last ) {
                index = i + 1;
            }
            item.selected = false;
            return item;
        });
        if( this.options.indexOf(index) !== -1 ) {
            this.options[index].selected = true;
        }
    }
    selectUp(e) {
        if( this.searchText == '' ) {
            return;
        }
        e.preventDefault();
        let index = this.options.length - 1;
        this.options = this.options.map((item, i) => {
            if( item.selected && i !== 0 ) {
                index = i - 1;
            }
            item.selected = false;
            return item;
        });
        if( this.options.indexOf(index) !== -1 ) {
            this.options[index].selected = true;
        }
    }
}